import rootStore from '@paybis/frontend-common-lib/src/store/index';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store(rootStore);

export default store;
